/**
 * 네이버 SA (Search Advisor) 유틸리티
 * @description 네이버 검색광고 전환 추적
 * 
 * 프로덕션 환경에서만 동작합니다.
 */

declare global {
  interface Window {
    wcs_add: Record<string, string>;
    wcs: {
      inflow: (domain?: string) => void;
      trans: (conv: { type: string }) => void;
    };
    wcs_do: () => void;
    _nasa: Record<string, unknown>;
  }
}

/** 네이버 SA 계정 ID */
const NAVER_SA_ACCOUNT_ID = 's_282dc06f4f63';

/** 도메인 (1차 도메인만) */
const DOMAIN = 'factsheet.kr';

/** 프로덕션 환경 여부 */
const isProduction = import.meta.env.VITE_NODE_ENV === 'production';

/** 초기화 여부 */
let isInitialized = false;

/**
 * 네이버 SA 초기화 (공통 스크립트)
 * - 프로덕션 환경에서만 동작
 * - 최초 1회만 실행
 */
export const initNaverSA = (): void => {
  if (typeof window === 'undefined') return;
  if (!isProduction) {
    console.log('[Naver SA] 프로덕션 환경이 아니므로 초기화하지 않습니다.');
    return;
  }
  if (isInitialized) {
    console.log('[Naver SA] 이미 초기화되었습니다.');
    return;
  }

  // wcslog.js 스크립트 로드
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//wcs.naver.net/wcslog.js';
  script.async = true;
  
  script.onload = () => {
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = NAVER_SA_ACCOUNT_ID;
    
    if (!window._nasa) window._nasa = {};
    
    if (window.wcs) {
      window.wcs.inflow(DOMAIN);
      window.wcs_do();
    }
    
    isInitialized = true;
    console.log('[Naver SA] 초기화 완료');
  };
  
  document.head.appendChild(script);
};

/**
 * 네이버 SA 초기화 상태 확인
 */
export const isNaverSAInitialized = (): boolean => {
  return isInitialized;
};

/**
 * 회원가입 전환 추적
 */
export const trackSignUp = (): void => {
  if (typeof window === 'undefined') return;
  if (!isProduction) {
    console.log('[Naver SA] 프로덕션 환경이 아니므로 전환 추적하지 않습니다.');
    return;
  }
  
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = NAVER_SA_ACCOUNT_ID;
    
    const _conv = { type: 'sign_up' };
    window.wcs.trans(_conv);
    
    console.log('[Naver SA] 회원가입 전환 추적 완료');
  } else {
    console.warn('[Naver SA] wcs가 로드되지 않았습니다.');
  }
};

/** 
 * 네이버 SA 이벤트 헬퍼
 */
export const NaverSAEvents = {
  /** 회원가입 전환 */
  signUp: trackSignUp,
};
